export const MATOMO_LOGICAL_NAME_COURSE_SEARCH = 'Kurse gesucht';
export const MATOMO_LOGICAL_NAME_CAREER_SEARCH = 'Karrieren gesucht';
export const MATOMO_LOGICAL_NAME_COURSE_TEMPLATE_OPENED = 'Kurs aufgerufen';
export const MATOMO_LOGICAL_NAME_COURSE_REGISTERED = 'Kurs Registrierung';
export const MATOMO_LOGICAL_NAME_CAREER_FAVORITED = 'Karriere zu Favoriten hinzugefügt';
export const MATOMO_LOGICAL_NAME_CAREER_LIKED = 'Karriere positiv bewertet';
export const MATOMO_LOGICAL_NAME_CAREER_DISLIKED = 'Karriere negativ bewertet';
export const MATOMO_LOGICAL_NAME_COURSE_STORED = 'Kurs zu Favoriten hinzugefügt';
export const MATOMO_LOGICAL_NAME_CAREER_AUTO_SKIPPED = 'Karriererichtung automatisch übersprungen';
